import React from 'react'

import {Flex} from '@daedalus/atlas/components/designSystem/helpers/Flex'
import {ContentWrapper} from '@daedalus/atlas/helpers/ContentWrapper'
import {Image} from '@daedalus/atlas/Image'
import placeHolderImage from '@daedalus/atlas/images/placeholder-hotel-image.svg'
import {StarRating} from '@daedalus/atlas/StarRating'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {ImageProvider} from '@daedalus/core/src/staticContent/types/ImageProvider'

import {Location} from '../../search/Location'
import {ReviewRating} from '../../search/ReviewRating'
import {TaxationAndNightlyPriceMessage} from '../../search/TaxationAndNightlyPriceMessage'
import {
  Container,
  HotelName,
  ImageContainer,
  InfoWrapper,
  NightlyOrTotalPriceWrapper,
  PlaceholderImageElement,
  ReviewRatingWrapper,
  TotalPriceMessage
} from './styles'

interface PropsType {
  showTotalPrices?: boolean
  imageProvider: ImageProvider
  hotelImageUrl: string
  starRating?: number
  hotelName: string
  hotelId: string
  place?: string
  reviewRaiting: number
  totalRatingCount?: number
  includeTaxes: boolean
}

export const HotelInfoCard = ({
  showTotalPrices = true,
  imageProvider,
  hotelImageUrl,
  starRating,
  hotelName,
  place,
  hotelId,
  reviewRaiting,
  totalRatingCount,
  includeTaxes
}: PropsType) => {
  return (
    <Container>
      <Flex.Row>
        <ImageContainer>
          {hotelImageUrl ? (
            <Image
              url={hotelImageUrl}
              imageProvider={imageProvider}
              placeHolderImage={placeHolderImage}
            />
          ) : (
            <PlaceholderImageElement src={placeHolderImage} alt="placeholder" />
          )}
        </ImageContainer>

        <InfoWrapper>
          <ContentWrapper
            paddingTop="s400"
            paddingX="s300"
            paddingBottom="s300"
          >
            {starRating && <StarRating size="xs" rating={starRating} />}
            <HotelName data-id="HotelName">{hotelName}</HotelName>
            {place && <Location place={place} hotelId={hotelId} />}
            <ReviewRatingWrapper>
              <ReviewRating
                rating={reviewRaiting}
                totalRatingCount={totalRatingCount}
                hotelId={hotelId}
              />
            </ReviewRatingWrapper>
            <NightlyOrTotalPriceWrapper
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              {showTotalPrices ? (
                <TotalPriceMessage data-id="TotalPriceMessage">
                  <FormattedMessageWrapper
                    id="payment.total"
                    defaultMessage="total"
                  />
                  &nbsp;
                  <FormattedMessageWrapper
                    id="includingTaxesShort"
                    defaultMessage="incl tax & fees"
                  />
                </TotalPriceMessage>
              ) : (
                <TaxationAndNightlyPriceMessage includeTaxes={includeTaxes} />
              )}
            </NightlyOrTotalPriceWrapper>
          </ContentWrapper>
        </InfoWrapper>
      </Flex.Row>
    </Container>
  )
}
